<template>
  <section class="chart-container">
    <el-row>
      <el-col :span="24" style="padding-top: 0px; padding-bottom: 0px">
        <span class="demonstration">From</span>
        <el-date-picker v-model="fromDateCalendar" type="date" placeholder="From" format="MM-dd-yyyy"
          @change="fromDateChanged($event)"> </el-date-picker>
        <span class="demonstration" style="padding-left: 40px">To</span>
        <el-date-picker v-model="toDateCalendar" type="date" placeholder="To" format="MM-dd-yyyy"
          @change="toDateChanged($event)"> </el-date-picker>
        <el-button type="info" size="medium" @click="csvExport()" style="margin-left: 20px;">Export to
          CSV</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div id="chartLine" style="width: 100%; height: 400px"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div id="chartPressureLine" style="width: 100%; height: 400px"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div id="chartExTemperatureLine" style="width: 100%; height: 400px"></div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import echarts from "echarts"
import Axios from "axios"
import IOService from "@/api/io.service"
import ExportToCsv from "export-to-csv"
import dateFormat from "dateformat"

export default {
  data() {
    return {
      mode: "NA",
      compensatorValue: "NA",
      showDatePicker: false,
      polling: null,
      apartmentSensorStatus: [],
      chartColumn: null,
      chartBar: null,
      chartLine: null,
      chartPressureLine: null,
      chartExTemperatureLine: null,
      chartPie: null,
      user: this.$session.get("User"),
      fortest: 0,
      //Temperature History
      zoneTemperatureHistoryData: [],
      zoneReturnTemperatureHistoryData: [],
      zoneDomesticWaterTemperatureHistoryData: [],
      zoneAuxHistoryData: [],
      //Motor History
      zoneMotorCurrentPositionHistoryData: [],
      zoneMotorTargetPositionHistoryData: [],
      //Pressure History
      zonePressureBoilerHistoryData: [],
      zonePressureSupplyHistoryData: [],
      zonePressureReturnHistoryData: [],
      //csvContent
      csvArray: [],

      /*These below are used by the date picker*/
      toDateCalendar: new Date().toISOString(),
      fromDateCalendar: new Date().toISOString(),
      toDate: new Date(),
      fromDate: new Date(),
      floor: null,
      apartment: null,
      csvOptions: {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Varivac Data Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      }
    }
  },

  methods: {
    csvExport() {
      var arrData = this.csvArray
      let csvContent = "data:text/csv;charset=utf-8,"
      csvContent += [Object.keys(arrData[0]).join(","), ...arrData.map((item) => Object.values(item).join(","))].join("\n").replace(/(^\[)|(\]$)/gm, "")

      const data = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", data)
      link.setAttribute("download", "export.csv")
      link.click()
    },
    fromDateChanged(event) {
      this.fromDate = new Date(event)
      this.getZoneHistory()
    },
    toDateChanged(event) {
      this.toDate = new Date(event)
      this.getZoneHistory()
    },
    getZoneModeText(val) {
      switch (val) {
        case 0:
          return "Auto"
        case 1:
          return "Valve Set"
        case 2:
          return "Manual"
        case 3:
          return "Program Mode"
        case 4:
          return "Pause"
        case 5:
          return "Off"
        case 6:
          return "Calibrate"
      }
      return ""
    },
    drawLineChart(zoneID) {
      this.showDatePicker = true
      this.chartLine = echarts.init(document.getElementById("chartLine"))
      this.chartLine.setOption({
        title: {
          text: "OAT and Valve Position"
        },

        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          formatter: (params) => {
            // create new marker
            this.getZoneMode(params[0].value[0])
            this.getZoneCompensatorSetting(params[0].value[0])

            var now = new Date(params[0].value[0])
            var dateFormatted = dateFormat(now, "m-dd-yyyy, h:MM TT")
            try {
              var result = `
                    Time: ${dateFormatted}</br>
                    OAT: ${params[0].value[1].toFixed(1)} °F</br>
                    Valve Position: ${params[1].value[1].toFixed(1)} %</br>
                    Valve Target: ${params[2].value[1].toFixed(1)} %</br>
                    Mode: ${this.getZoneModeText(this.mode)}</br>
                    Compenator: ${this.compensatorValue}`
              return result
            } catch (Exception) {
              return ""
            }
          },
          textStyle: {
            fontSize: 12
          }
        },
        //       tooltip: {
        //   trigger: "axis"
        // },
        legend: {
          data: ["OAT", "Valve Current Position", "Valve Target Position"],
          x: "right"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: [
          {
            type: "value",
            name: "Temperature",
            min: 0,
            max: 110,
            axisLabel: { formatter: "{value} °F" }
          },
          {
            type: "value",
            name: "Valve Position",
            min: 0,
            max: 100,
            axisLabel: { formatter: "{value} %" }
          }
        ],
        series: [
          //We need Mode and comp position
          {
            name: "OAT",
            type: "line",

            showSymbol: false,
            data: this.zoneTemperatureHistoryData
          },
          {
            name: "Valve Current Position",
            type: "line",

            showSymbol: false,
            yAxisIndex: 1,
            data: this.zoneMotorCurrentPositionHistoryData
          },
          {
            name: "Valve Target Position",
            type: "line",
            lineStyle: {
              type: "dashed"
            },
            showSymbol: false,
            yAxisIndex: 1,
            data: this.zoneMotorTargetPositionHistoryData
          }
        ]
      })
    },
    drawPressureLineChart(zoneID) {
      this.chartPressureLine = echarts.init(document.getElementById("chartPressureLine"))
      this.chartPressureLine.setOption({
        title: {
          text: "Pressure"
        },
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          formatter: (params) => {
            // create new marker
            var now = new Date(params[0].value[0])
            var dateFormatted = dateFormat(now, "m-dd-yyyy, h:MM TT")
            try {
              var result = `
                    Time: ${dateFormatted}</br>
                    Boiler Pressure: ${params[0].value[1].toFixed(1)} PSI</br>
                    Return Pressure: ${params[1].value[1].toFixed(1)} "inHg</br>
                    Supply Pressure: ${params[2].value[1].toFixed(1)} "inHg</br>`
              return result
            } catch (Exception) {
              return ""
            }
          },
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          data: ["Boiler Pressure", "Return Pressure", "Supply Pressure"],
          x: "right"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: [
          {
            type: "value",
            name: "Pressure (PSI)",
            min: -10,
            max: 10,
            axisLabel: { formatter: "{value} PSI" }
          },
          {
            type: "value",
            name: `Pressure ("Hg)`,
            min: -35.36,
            max: 35.36,
            axisLabel: { formatter: `{value} "inHg` }
          }
          // {
          //   type: "value",
          //   name: "Motor Position",
          //   min: 0,
          //   max: 100,
          //   axisLabel: { formatter: "{value} %" }
          // }
        ],
        series: [
          {
            name: "Boiler Pressure",
            type: "line",

            showSymbol: false,
            data: this.zonePressureBoilerHistoryData
          },
          {
            name: "Return Pressure",
            type: "line",

            showSymbol: false,
            yAxisIndex: 1,
            data: this.zonePressureReturnHistoryData
          },
          {
            name: "Supply Pressure",
            type: "line",
            showSymbol: false,
            yAxisIndex: 1,
            data: this.zonePressureSupplyHistoryData
          }
        ]
      })
    },
    drawExTemperatureLineChart(zoneID) {
      this.chartExTemperatureLine = echarts.init(document.getElementById("chartExTemperatureLine"))
      this.chartExTemperatureLine.setOption({
        title: {
          text: "Return and Domestic Water Temp"
        },
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          formatter: (params) => {
            // create new marker
            var now = new Date(params[0].value[0])
            var dateFormatted = dateFormat(now, "m-dd-yyyy, h:MM TT")
            try {
              var result = `
                    Time: ${dateFormatted}</br>
                    Return Temp: ${params[0].value[1].toFixed(1)} °F</br>
                    Domestic Water Temp: ${params[1].value[1].toFixed(1)} °F</br>
                    Aux: ${params[1].value[1].toFixed(1)} °F</br>`
              return result
            } catch (Exception) {
              return ""
            }
          },
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          data: ["Return Temp", "Domestic Water Temp", "Aux"],
          x: "right"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false
        },
        yAxis: [
          {
            type: "value",
            name: "Temperature",
            // min: -10,
            // max: 10,
            axisLabel: { formatter: "{value} °F" }
          }
        ],
        series: [
          {
            name: "Return Temp",
            type: "line",

            showSymbol: false,
            data: this.zoneReturnTemperatureHistoryData
          },
          {
            name: "Domestic Water Temp",
            type: "line",

            showSymbol: false,
            //yAxisIndex: 1,
            data: this.zoneDomesticWaterTemperatureHistoryData
          },
          {
            name: "Aux",
            type: "line",

            showSymbol: false,
            //yAxisIndex: 1,
            data: this.zoneAuxHistoryData
          }
        ]
      })
    },
    async getZoneMode(time) {
      var modeResult = await IOService.getZoneMode(this.user.activeZone, time)
      if (modeResult.data.length > 0) {
        this.mode = modeResult.data[0].mode
      } else {
        this.mode = 'NA'
      }
    },
    async getZoneCompensatorSetting(time) {
      var compensatorResult = await IOService.getZoneCompensatorSetting(this.user.activeZone, time)
      if (compensatorResult.data.length < 1) {
        this.compensatorValue = "NA"
      } else {
        this.compensatorValue = compensatorResult.data[0].compensatorValue
      }
    },

    getZoneHistory() {
      var toDate = this.toDate
      toDate.setUTCHours(23)
      toDate.setUTCMinutes(59)
      var toDateFormatted = toDate.toISOString()
      var fromDateFormatted = this.fromDate.toISOString()
      Axios.all([
        IOService.getZoneTemperatureHistory(this.user.activeZone, fromDateFormatted, toDateFormatted),
        IOService.getZoneMonitorCurrentPositionHistory(this.user.activeZone, fromDateFormatted, toDateFormatted),
        IOService.getZoneMonitorTargetPositionHistory(this.user.activeZone, fromDateFormatted, toDateFormatted),
        IOService.getZonePressureBoilerHistory(this.user.activeZone, fromDateFormatted, toDateFormatted)
      ]).then(
        Axios.spread((ZoneTemperatureResponse, ZoneMotorCurrentPositionResponse, ZoneMotorTargetPositionResponse, ZonePressureBoilerResponse) => {
          this.zoneTemperatureHistoryData = []
          this.zoneMotorCurrentPositionHistoryData = []
          this.zoneMotorTargetPositionHistoryData = []
          this.zonePressureBoilerHistoryData = []
          this.zonePressureSupplyHistoryData = []
          this.zonePressureReturnHistoryData = []
          this.zoneReturnTemperatureHistoryData = []
          this.zoneDomesticWaterTemperatureHistoryData = []
          this.zoneAuxHistoryData = []

          for (let item of ZoneTemperatureResponse.data) {
            this.zoneTemperatureHistoryData.push([item.time, item.temperature])
            this.zoneReturnTemperatureHistoryData.push([item.time, item.returnLine])
            this.zoneDomesticWaterTemperatureHistoryData.push([item.time, item.domesticWater])
            this.zoneAuxHistoryData.push([item.time, item.auxiliary])
            //this.apartmentHistoryAxis.push(item.time);
          }
          for (let item of ZoneMotorCurrentPositionResponse.data) {
            this.zoneMotorCurrentPositionHistoryData.push([item.time, item.currentPosition])
          }

          for (let item of ZoneMotorTargetPositionResponse.data) {
            this.zoneMotorTargetPositionHistoryData.push([item.time, item.targetPosition])
          }

          for (let item of ZonePressureBoilerResponse.data) {
            this.zonePressureBoilerHistoryData.push([item.time, item.boiler])
            if (item.boiler == null) {
              this.zonePressureSupplyHistoryData.push([item.time, null])
              this.zonePressureReturnHistoryData.push([item.time, null])
            } else {
              this.zonePressureSupplyHistoryData.push([item.time, item.supply * 2.036])
              this.zonePressureReturnHistoryData.push([item.time, item.return * 2.036])
            }
          }

          this.csvArray = [];
          this.csvArray.push([
            'time',
            'Outdoor Temperature (°F)',
            'Return Temperature (°F)',
            'Domestic Water (°F)',
            'Valve Current Position (%)',
            'Valve Target Position (%)',
            'Boiler Pressure (PSI)',
            'Supply Pressure (inHg)',
            'Return Pressure (inHg)',
          ])
          for (var index = 0; index < ZoneTemperatureResponse.data.length; index++) {
            if (ZoneTemperatureResponse.data[index].temperature != null) {
              var date = new Date(ZoneTemperatureResponse.data[index].time);
              // "Wed Jun 29 2011 09:52:48 GMT-0700 (PDT)"
              this.csvArray.push([
                //ZoneTemperatureResponse.data[index].time,
                date.toString(),
                ZoneTemperatureResponse.data[index].temperature,
                ZoneTemperatureResponse.data[index].returnLine,
                ZoneTemperatureResponse.data[index].domesticWater,
                ZoneMotorCurrentPositionResponse.data[index].currentPosition,
                ZoneMotorTargetPositionResponse.data[index].targetPosition,
                ZonePressureBoilerResponse.data[index].boiler,
                ZonePressureBoilerResponse.data[index].supply * 2.036,
                ZonePressureBoilerResponse.data[index].return * 2.036,
              ])
            }
          }


          this.drawLineChart(this.user.activeZone)
          this.drawPressureLineChart(this.user.activeZone)
          this.drawExTemperatureLineChart(this.user.activeZone)
        })
      )
    },
    toFahrenheit(degC) {
      console.log(degC)
      if (typeof degC === "undefined") {
        return ""
      } else {
        return (degC * (9 / 5) + 32).toFixed(1) + "°F"
      }
    },
    compare(a, b) {
      return a.floor < b.floor ? 1 : -1
    },
    isInArray(floor) {
      for (var i = 0; i < this.apartmentSensorStatus.length; i++) {
        if (this.apartmentSensorStatus[i].floor == floor) {
          return i
        }
      }
      return -1
    }
  },

  mounted: function () {
    var yesterday = new Date()
    yesterday.setDate(new Date().getDate() - 8)
    this.fromDate = yesterday
    this.fromDateCalendar = yesterday.toISOString()

    this.getZoneHistory()
    //this.drawLineChart(17, "A");
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  updated: function () {
    //this.drawCharts();
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}

/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// Archive.vue?02f9446e